export default [
  {
    path: "/marketing/faqs",
    name: "FAQ",
    component: () => import("@/modules/marketing/faq/views/FaqList.vue"),
  },
  {
    path: "/marketing/advertisement/view/:id",
    name: "ViewAdvertisement",
    component: () =>
      import(
        "@/modules/marketing/advertisement/views/AdvertisementMetrices.vue"
      ),
  },
  {
    path: "/marketing/advertisement",
    name: "AdvertisementList",
    component: () =>
      import("@/modules/marketing/advertisement/views/AdvertisementList.vue"),
  },
  {
    path: "/marketing/coupons",
    name: "Coupon",
    component: () => import("@/modules/marketing/coupons/views/CouponList.vue"),
  },
  {
    path: "/marketing/refferals",
    name: "Refferal",
    meta: { title: "Refferals" },
    component: () =>
      import("@/modules/marketing/referrals/views/RefferalsList.vue"),
  },
  {
    path: "/refferal/view/:id",
    name: "viewRefferal",
    meta: { title: "View Refferal" },
    component: () => import("@/modules/marketing/referrals/views/Refferal.vue"),
  },
  {
    path: "/marketing/bonus",
    name: "BonusList",
    component: () => import("@/modules/activity-management/manage-app/views/BonusList.vue"),
  },
];
